import { ImgHTMLAttributes } from 'react'

import { getImageUrl } from './helpers'
import { ResizeFit } from './types'

interface ColorCode {
  hex: string
  alpha?: number
}

interface mediaQuery {
  screen: string
  width: string
  srcKey?: string
}

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  bucket?: string
  className?: string
  imageClassName?: string
  fit?: ResizeFit
  height?: number
  srcKey: string
  width?: number
  alt?: string
  fetchPriority?: 'low' | 'high' | undefined
  loading?: 'lazy' | 'eager' | undefined
  lazyLoad?: boolean
  fitBgColor?: ColorCode
  quality?: number
  mediaQuery?: mediaQuery[]
  imageWidths?: number[]
  types?: string[]
  onClick?: () => void
}

const queries: mediaQuery[] = [{ screen: '(min-width: 280px)', width: '100vw' }]

export default function SVGImage(props: Props): React.ReactElement {
  const {
    alt = '',
    className = '',
    imageClassName = '',
    bucket,
    fit = 'cover',
    height,
    srcKey,
    width,
    loading = 'lazy',
    fetchPriority,
    fitBgColor,
    mediaQuery = queries,
    onClick,
    ...rest
  } = props
  const getOriginalSrc = (rawSrc: string): string => {
    return `${getImageUrl(height, width, fit, rawSrc, bucket, fitBgColor).urlOriginal}`
  }

  const createSources = (query: mediaQuery): React.ReactElement => {
    return (
      <source
        key={query.screen}
        media={query.screen}
        srcSet={getOriginalSrc(query.srcKey ?? srcKey)}
        type="image/svg"
      />
    )
  }

  return (
    <picture className={className}>
      {mediaQuery.map(createSources)}
      <img
        alt={alt}
        className={imageClassName}
        // eslint-disable-next-line react/no-unknown-property
        fetchPriority={fetchPriority ?? loading === 'lazy' ? 'low' : 'high'}
        height={height}
        loading={loading}
        onClick={onClick}
        src={getOriginalSrc(srcKey)}
        width={width}
        {...rest}
      />
    </picture>
  )
}
